export default __webpack_public_path__ + "static/assets/a3e2db68a0243f03e75104ffd9d70972.jpg";